import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function TermsPage() {
  useEffect(() => {
    document.title = 'Terms & Conditions | Sunlight Grounds Care';
  }, []);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="terms-page">
      {/* Hero Section */}
      <section className="bg-[#1a2e44] py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h1 className="text-3xl md:text-4xl font-bold text-white">
            Terms & Conditions
          </h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="bg-white p-8 md:p-12 rounded-lg shadow-sm border border-slate-200">
            <h2 className="text-2xl font-bold text-[#1a2e44] mb-6">
              SMS Terms & Conditions
            </h2>
            
            <div className="prose prose-slate max-w-none space-y-6">
              <p className="text-slate-600">
                By opting in to receive SMS messages from Sunlight Grounds Care, you agree to receive messages related to:
              </p>

              <ul className="list-disc pl-6 space-y-2 text-slate-600">
                <li>Appointment confirmations</li>
                <li>Service updates</li>
                <li>Account notifications</li>
              </ul>

              <p className="text-slate-600">
                Message frequency may vary.
              </p>

              <p className="text-slate-600">
                Message and data rates may apply.
              </p>

              <div className="bg-slate-50 p-4 rounded-lg border border-slate-200">
                <p className="text-slate-700 font-medium">
                  To opt out at any time, reply <span className="font-bold">STOP</span>.
                </p>
                <p className="text-slate-700 font-medium mt-2">
                  For help, reply <span className="font-bold">HELP</span> or visit{' '}
                  <a href="https://www.sunlightgroundscare.com" className="text-[#1a2e44] hover:underline">
                    www.sunlightgroundscare.com
                  </a>
                </p>
              </div>

              <div className="pt-6 border-t border-slate-200">
                <p className="text-slate-600">
                  See our Privacy Policy at:{' '}
                  <Link to="/privacy" className="text-[#1a2e44] font-medium hover:underline">
                    https://sunlightgroundscare.com/privacy
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
